import React from 'react'
import { startCase } from 'lodash-es'
import { useTranslation } from 'react-i18next'
import { Box, CopyButton, Highlight, Tooltip } from '@node-space/ui-components'
import { ellipseMiddleText } from '@node-space/utils'
import { SidePanelHeaderTemplateTwo } from 'components/SidePanel/SidePanelHeaderTemplates/SidePanelHeaderTemplateTwo'
import { PendingTransactionsResponse } from 'types/approvals'
import { getHighlightType, titleCase } from 'utils/utils'

interface SidePanelHeaderTemplateProps {
  transactionDetails: PendingTransactionsResponse
}

export const SidePanelHeaderTemplate = ({ transactionDetails }: SidePanelHeaderTemplateProps) => {
  const { t } = useTranslation()
  const iconUrl = `${process.env.ICONS_URL}${transactionDetails?.currency?.code?.toLowerCase()}.svg`

  return (
    <SidePanelHeaderTemplateTwo
      heading={{
        iconUrls: [iconUrl],
        primaryLabel: `${transactionDetails?.amount} ${transactionDetails?.currency?.code}`,
        secondaryLabel: startCase(transactionDetails?.type),
      }}
    >
      <Box flexCol className="pl-10" gap={4}>
        {transactionDetails?.userReference && (
          <Box flex gapX={4}>
            <p className="text-foreground-prominent text-body-regular">
              {ellipseMiddleText(transactionDetails?.userReference, 10, 10)}
            </p>
            <Tooltip bodyContent={t('copyReference')} type="simple">
              <Box flex align="center">
                <CopyButton copyText={transactionDetails?.userReference} />
              </Box>
            </Tooltip>
          </Box>
        )}
        <Box>
          <Highlight type={getHighlightType(transactionDetails?.status?.toUpperCase())}>
            {titleCase(transactionDetails?.status)}
          </Highlight>
        </Box>
      </Box>
    </SidePanelHeaderTemplateTwo>
  )
}
